import React from 'react'
import { BREAKPOINT_EXTRA_SMALL, CX, SEARCH_TABS } from '../constants'
import Layout from '../layouts/layout'
import PageTitle from '../features/ui/util/page_title'
import FooterBar from '../components/footer_bar'
import WrappedBundle from '../features/ui/util/wrapped_bundle'
import { SidebarXS } from '../features/ui/util/async_components'
import Pills from '../components/pills'
import { parseQuerystring } from '../utils/querystring'
import SearchNavigationBarXS from '../components/navigation_bar/search_navigation_bar_xs'

export default function SearchLayout({ children }) {
  const { q } = parseQuerystring({ q: '' })
  let pageTitle = 'Search'
  const { pathname } = window.location
  const tabs = SEARCH_TABS.map(({ title, to }, index) => ({
    title,
    to: `${to}?q=${encodeURIComponent(q)}`,
    active: to === pathname
  }))
  const selectedTab = tabs.find(item => item.active)
  if (selectedTab) {
    pageTitle = `${pageTitle} ${selectedTab.title}`
  }

  if (window.innerWidth <= BREAKPOINT_EXTRA_SMALL) {
    return (
      <div className={[_s.d, _s.w100PC, _s.minH100VH, _s.bgTertiary].join(' ')}>
        <WrappedBundle component={SidebarXS} />
        <SearchNavigationBarXS />
        <div className={[_s.d, _s.flexRow, _s.w100PC, _s.flexGrow1].join(' ')}>
          <div className={[_s.d, _s.w100PC].join(' ')}>
            <main role='main'>
              <div className={[_s.d, _s.w100PC, _s.jcEnd, _s.pb15].join(' ')}>
                <div className={[_s.d, _s.w100PC, _s.py15].join(' ')}>
                  <Pills pills={tabs} />
                </div>
                {children}
              </div>
            </main>
          </div>
        </div>
        <FooterBar />
      </div>
    )
  }

  return (
    <Layout
      noRightSidebar
      noComposeButton
      title={pageTitle}
      tabs={tabs}
      page={`search.${q}`}
    >
      <PageTitle path={pageTitle} />
      <div className={[_s.d, _s.w100PC].join(' ')}>
        {children}
      </div>
    </Layout>
  )
}
